import moment from "moment"
import { getToDay, Aggregator, DataBase } from "./Interrelated"


const [startDates, endDates] = getToDay()

enum RightEq { false = '>=', true = '>' }
enum LeftEq { true = '<=', false = '<' }

type ArrayStrNum = Array<string | number>
type FilterValueType = string | number | ArrayStrNum
interface Filter { key: string, value: FilterValueType }

/** 查询条件实体 */
export class Condit {
  /**
   *
   * @param dataSource  表名
   * @param dimensions  分组字段
   * @param aggregators 聚合字段
   * @param startDate   起始时间
   * @param endDate     结束时间
   * @param queryType   查询类型 默认: groupBy
   * @param simpleGranularity  密度 默认: all
   */
  constructor(
    dataSource: DataBase, dimensions: Array<string>, aggregators: Array<Aggregator>,
    startDate: string, endDate: string,
    queryType: string, simpleGranularity: string,
    durationGranularity?: string,
    offset?: number, limit?: number,
    andFilters?: Array<Filter>,
    inFilters?: Array<Filter>,
    notFilters?: Array<Filter>,
    likeFilters?: Array<Filter>,
    boundFilters?: Array<Bound>,
  ) {

    this.dataSource = dataSource
    this.queryType = queryType
    this.startDate = startDate
    this.endDate = endDate
    this.simpleGranularity = simpleGranularity
    this.durationGranularity = durationGranularity
    this.offset = offset
    this.limit = limit
    this.dimensions = [...dimensions]
    this.aggregators = [...aggregators]
    if (andFilters)
      this.andFilters = [...andFilters]
    if (inFilters)
      this.inFilters = [...inFilters]
    if (notFilters)
      this.notFilters = [...notFilters]
    if (likeFilters)
      this.likeFilters = [...likeFilters]
    if (boundFilters)
      this.boundFilters = [...boundFilters]
  }
  /** 表名 */
  protected dataSource: string
  /** 查询类型 */
  protected queryType: string
  /** 分组字段 */
  protected dimensions: Array<string>
  /** 聚合字段 */
  protected aggregators: Array<Aggregator>
  /** 扫描开始时间 */
  protected startDate: string
  /** 扫描结束时间 */
  protected endDate: string
  /** 密度 */
  protected simpleGranularity: string

  //// 以下为可空条件
  /** 时间分段 */
  protected durationGranularity?: string
  /** 并且查询条件 */
  protected andFilters?: Array<Filter>
  /** 并且多查询条件 */
  protected inFilters?: Array<Filter>
  /** 查询非条件 */
  protected notFilters?: Array<Filter>
  /** 模糊匹配条件 */
  protected likeFilters?: Array<Filter>
  /** 用于区间范围条件【例如:装卸卸时间范围，件数范围】 */
  protected boundFilters?: Array<Bound>

  /** 查询条数 */
  protected limit?: number
  /** 跳过条数 */
  protected offset?: number


  toSQL(): string {
    //#region 聚合
    const aggs = this.aggregators.map(aggItem => {
      return ` ${aggItem.type === 'count' ? 'count' : 'sum'}(${aggItem.name})`
    })
    //#endregion

    //#region 查询条件
    const fliterToSql = (filter: Array<Filter>, call) => {
      let temp = ''
      if (filter?.length > 0) {
        filter.forEach(item => temp += call(item) + '\n\t  ')
      }
      return temp
    }
    const andf = fliterToSql(this.andFilters, (item: Filter) => `and ${item.key} = '${item.value}'`)
    const inf = fliterToSql(this.inFilters, (item: Filter) => `and ${item.key} in (${(item.value as ArrayStrNum).map(m => `'${m}'`)})`)
    const notf = fliterToSql(this.notFilters, (item: Filter) => `and ${item.key} not in ('${item.value}')`)
    //#endregion

    //#region bound查询条件
    let boundf = ''
    this.boundFilters?.forEach((bound: Bound) => {
      boundf += (`
      and ${bound.dimension} ${RightEq[`${bound.lowerEq}`]} '${bound.lowerValue}'
      and ${bound.dimension} ${LeftEq[`${bound.upperEq}`]} '${bound.upperValue}' \n`
      )
    })
    //#endregion

    //#region 拼接转换为SQL语句
    // let filter =

    const groupBy = this.dimensions.toString().replace(',', ', ')

    let sqlL = (
      `select ${groupBy},${aggs.toString()}  from ${this.dataSource}\n  where
      __time >= '${this.startDate}' and
      __time < '${this.endDate}'
      ${boundf}
      ${andf}
      ${inf}
      ${notf}
      group by ${groupBy}`
    )
    //#endregion
    return sqlL
  }
}



/**
 * BoundFilter查询字段实体
 */
export class Bound {
  /**
   *
   * @param dimension   Bound字段
   * @param lowerValue  左区间
   * @param upperValue  右区间
   * @param lowerEq     默认: false
   * @param upperEq     默认: false
   */
  constructor(
    dimension: string, lowerValue?: string, upperValue?: string,
    lowerEq: boolean = false, upperEq: boolean = false
  ) {
    this.dimension = dimension
    this.lowerValue = lowerValue
    this.upperValue = upperValue
    this.lowerEq = lowerEq
    this.upperEq = upperEq
  }
  /** 字段 */
  dimension: string
  /** 左区间 */
  lowerValue: string
  /** 右区间 */
  upperValue: string
  lowerEq: boolean
  upperEq: boolean

  //#region 修改时间参数
  setDateime(dateTime: Array<moment.MomentInput>, dateFormat: string = 'YYYY-MM-DD HH:mm:ss') {
    if (dateTime[0])
      this.lowerValue = moment(dateTime[0]).format(dateFormat)
    if (dateTime[1])
      this.upperValue = moment(dateTime[1]).format(dateFormat)
  }

  lowerValueAdd(day: moment.DurationInputArg1, type: moment.unitOfTime.DurationConstructor = 'days') {
    const date = moment(this.lowerValue)
    this.setDateime([date.add(day, type), null], date['_f'])
  }

  upperValueAdd(day: moment.DurationInputArg1, type: moment.unitOfTime.DurationConstructor = 'days') {
    const date = moment(this.upperValue)
    this.setDateime([date.add(day, type), null], date['_f'])
  }
  //#endregion
}

export interface IGnerCondit {
  dataSource: DataBase
  dimensions: Array<string>
  aggregators: Array<Aggregator>
  queryType?: 'topN' | 'groupBy' | 'timeSeries' | 'scan' | 'timeSeries'
  simpleGranularity?: 'all' | 'second' | 'minute' | 'fifteen_minute' |
  'thirty_minute' | 'hour' | 'day' | 'week' | 'month' | 'quarter' | 'year'
  durationGranularity?: string
  startDate?: string
  endDate?: string
  offset?: number
  limit?: number
}

/**
 * Druid查询
 */
export default class GenerateCondit<T> extends Condit {
  constructor(newGc: IGnerCondit) {
    const {
      dataSource, dimensions, aggregators,
      startDate = moment(newGc.startDate ?? startDates).format('YYYY-MM-DD HH:mm:ss'),
      endDate = moment(newGc.endDate ?? endDates).format('YYYY-MM-DD HH:mm:ss'),
      queryType = 'groupBy', simpleGranularity = 'all',
      durationGranularity,
      offset, limit
    } = newGc
    super(
      dataSource, dimensions || [], aggregators || [],
      startDate, endDate, queryType, simpleGranularity,
      durationGranularity,
      offset, limit
    );

    this.andFilters = []
    this.inFilters = []
    this.notFilters = []
    this.likeFilters = []
    this.boundFilters = []
  }

  //#region 修改查询数据表
  setDataSource(baseName: DataBase) {
    this.dataSource = baseName
  }
  //#endregion

  //#region 修改时间参数
  setDateime(dateTime: Array<moment.MomentInput>) {
    if (dateTime[0])
      this.startDate = moment(dateTime[0]).format('YYYY-MM-DD HH:mm:ss')
    if (dateTime[1])
      this.endDate = moment(dateTime[1]).format('YYYY-MM-DD HH:mm:ss')
  }

  startDateAdd(day: moment.DurationInputArg1, type: moment.unitOfTime.DurationConstructor = 'days') {
    this.setDateime([moment(this.startDate).add(day, type), null])
  }

  endDateAdd(day: moment.DurationInputArg1, type: moment.unitOfTime.DurationConstructor = 'days') {
    this.setDateime([null, moment(this.endDate).add(day, type)])
  }
  //#endregion

  //#region 设置boundFilters

  /** 替换当前boundFilters设置 */
  setBoundFilters(bounds: Array<Bound>) {
    this.boundFilters = bounds
  }

  /** 增加boundFilters查询条件
   *  如果已存在相同项则会替换,以dimension作为是否存在依据
   */
  pushBoundFilters(bound: Bound): this {
    this.boundFilters.find((boundItem, index) => {
      const isFind = (boundItem.dimension === bound.dimension)
      if (isFind) {
        this.boundFilters.splice(index, 1)
      }
      return isFind
    })
    this.boundFilters.push(bound)
    return this
  }
  //#endregion

  /**
   *
   * @param entity 实体字段,查询条件
   * @param isDeepCopy 是否返回深拷贝配置,会创新一个新的 Condit
   * @returns Condit配置对象
   */
  converCondit(entity: T, isDeepCopy: boolean = true): Condit {
    this.andFilters = []
    this.inFilters = []
    this.likeFilters = []
    this.notFilters = []
    Object.entries(entity).forEach(([key, value]) => {
      if (value) {
        // andFilters
        if (typeof value === 'string' || typeof value === 'number') {
          this.andFilters.push({ key, value });
          return
          // inFilters
        } else if (Array.isArray(value) && value.length > 0) {
          this.inFilters.push({ key, value })
          return
          // notFilters
        } else if (value.notValue) {
          if (Array.isArray(value.notValue) && value.notValue.length > 0) {
            value.notValue.forEach((notItm: any) => {
              this.notFilters.push({ key, value: notItm })
            })
            return
          }
          this.notFilters.push({ key, value: value.notValue })
          return
        } else if (value.likeValue) {
          this.likeFilters.push({ key, value: value.likeValue });
          return
        }
      }
    })
    const filterNull = ['andFilters', 'inFilters', 'likeFilters', 'notFilters', 'offset', 'limit']
    filterNull.forEach(filed => {
      if (!this[filed] || this[filed]?.length === 0) {
        delete this[filed]
      }
    })

    if (isDeepCopy) {
      /** 深拷贝配置 */
      // condit = JSON.parse(JSON.stringify(condit))
      // 创建新副本
      return new Condit(
        this.dataSource as DataBase, this.dimensions, this.aggregators,
        this.startDate, this.endDate, this.queryType, this.simpleGranularity,
        this.durationGranularity,
        this.offset, this.limit,
        this.andFilters, this.inFilters, this.notFilters, this.likeFilters, this.boundFilters
      );
    }
    return this
  }
}
